import script from "./BlogForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogForm.vue?vue&type=script&setup=true&lang=ts"

import "./BlogForm.vue?vue&type=style&index=0&id=4097d018&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4097d018"]])

export default __exports__